import { Injectable } from '@visiba/instantiation';
import { EventEmitter } from '@visiba/std';

@Injectable()
export class CaseCommunicator extends EventEmitter<{
	removeAppointment: string;
	removeMessagingCase: number;
}> {
	constructor() {
		super();
	}

	public removeAppointmentCase(id: string) {
		this.emit('removeAppointment', id);
	}

	public removeMessagingCase(id: number) {
		this.emit('removeMessagingCase', id);
	}
}
